import { useMemo, useState } from "react";
import FadeIn from "@/components/FadeIn";
import { IMG } from "@/data/images";

const CATEGORIES = [
  { key: "toate", label: "Toate" },
  { key: "rosu", label: "La Roșu" },
  { key: "cheie", label: "La Cheie" },
  { key: "ansamblu", label: "Ansambluri" },
  { key: "renovare", label: "Renovări" },
];

const PROJECTS = [
  { cat: "cheie", name: "Vila Gheorghiu", loc: "Iași, Bucium", year: "2023", desc: "Vilă P+1+M, 280mp, finisaje premium" },
  { cat: "rosu", name: "Casa Moldovan", loc: "Iași, Miroslava", year: "2023", desc: "Casă unifamilială P+1, 190mp, structură beton armat" },
  { cat: "ansamblu", name: "Rezidențial Păcurari", loc: "Iași", year: "2022", desc: "Complex 12 case individuale, infrastructură completă" },
  { cat: "cheie", name: "Vila Tudorache", loc: "Pașcani", year: "2022", desc: "Vilă P+M, 220mp, terasă panoramică" },
  { cat: "renovare", name: "Renovare Ciobanu", loc: "Iași, Tătărași", year: "2022", desc: "Renovare completă apartament 4 camere, 95mp" },
  { cat: "rosu", name: "Casa Nistor", loc: "Iași, Lunca Cetățuii", year: "2021", desc: "Casă P+1, 160mp, fundație pe piloți" },
  { cat: "cheie", name: "Casa Apostol", loc: "Roman", year: "2021", desc: "Casă la cheie P+1, 210mp, finisaje moderne" },
  { cat: "ansamblu", name: "Ansamblu Copou", loc: "Iași, Copou", year: "2021", desc: "8 vile individuale cu spații verzi comune" },
  { cat: "renovare", name: "Extindere Lupu", loc: "Iași", year: "2020", desc: "Extindere mansardă + renovare completă interior" },
  { cat: "cheie", name: "Vila Enache", loc: "Iași, Galata", year: "2020", desc: "Vilă P+1+M, 310mp, piscină exterioară" },
  { cat: "rosu", name: "Casa Popa", loc: "Vaslui", year: "2020", desc: "Casă P, 130mp, structură zidărie portantă" },
  { cat: "cheie", name: "Casa Rusu", loc: "Iași, Valea Lupului", year: "2019", desc: "Casă P+1, 175mp, finisaje rustice" },
];

const CAT_LABELS = {
  rosu: "La Roșu",
  cheie: "La Cheie",
  ansamblu: "Ansamblu",
  renovare: "Renovare",
};

export default function Proiecte() {
  const [filter, setFilter] = useState("toate");

  const visible = useMemo(
    () => (filter === "toate" ? PROJECTS : PROJECTS.filter((p) => p.cat === filter)),
    [filter]
  );

  return (
    <div data-testid="proiecte-page">
      <header className="sb-page-header">
        <div className="sb-container">
          <h1>Proiectele Noastre</h1>
          <p>Peste 200 de proiecte finalizate în Iași și regiunile limitrofe</p>
        </div>
      </header>

      <section className="sb-section">
        <div className="sb-container">
          <div className="sb-filters" data-testid="project-filters" role="tablist" aria-label="Filtrare proiecte">
            {CATEGORIES.map((c) => (
              <button
                key={c.key}
                type="button"
                role="tab"
                aria-selected={filter === c.key}
                className={`sb-filter-btn ${filter === c.key ? "active" : ""}`}
                onClick={() => setFilter(c.key)}
                data-testid={`filter-btn-${c.key}`}
              >
                {c.label}
              </button>
            ))}
          </div>

          <div className="sb-projects-grid" data-testid="projects-grid">
            {visible.map((p, idx) => {
              const realIdx = PROJECTS.indexOf(p);
              return (
                <FadeIn key={p.name} delay={(idx % 6) * 70}>
                  <article className="sb-project-card" data-testid={`project-card-${realIdx}`}>
                    <div className="sb-project-image">
                      <img
                        src={IMG.projects[realIdx]}
                        alt={`Proiect ${p.name} - ${p.loc}`}
                        className="sb-img-cover"
                        width="600"
                        height="400"
                        loading="lazy"
                      />
                    </div>
                    <div className="sb-project-body">
                      <span className="sb-project-badge">{CAT_LABELS[p.cat]}</span>
                      <h3>{p.name}</h3>
                      <div className="sb-project-meta">
                        {p.loc} · {p.year}
                      </div>
                      <div className="sb-project-desc">{p.desc}</div>
                    </div>
                  </article>
                </FadeIn>
              );
            })}
          </div>

          {visible.length === 0 && (
            <div style={{ textAlign: "center", padding: "3rem 0", color: "var(--sb-body-gray)" }}>
              Niciun proiect în această categorie.
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
